import React from "react";
import CoreEngine from "../../core/CoreEngine";
import FormPage from "../../components/Form/FormPage";
import ServiceDetailForm from "./ServiceDetailForm";
import strings from "../../core/translate";

// Direct link version of the service detail dialog.
export default class MerchantBranchServiceDetailAddUpdate extends CoreEngine {
  getContext() {
    const routeState = this.props.location.state || {};
    const { selectedBranch, selectedService } = this.props.match.params;
    return {
      selectedBranch: routeState.selectedBranch || selectedBranch,
      selectedService: routeState.selectedService || selectedService,
      selectedMerchant: routeState.selectedMerchant,
      branchName: routeState.branchName,
    };
  }

  handleDone = () => {
    const { selectedBranch, selectedService, selectedMerchant, branchName } =
      this.getContext();
    this.props.history.push({
      pathname: `/admin/merchants-branches/${selectedBranch}/services/${selectedService}/details`,
      state: { selectedMerchant, selectedBranch, branchName },
    });
  };

  render() {
    const { selectedBranch, selectedService, branchName } = this.getContext();
    const item = this.props.location.data;

    return (
      <FormPage
        title={
          item && item.id
            ? strings.edit_service_detail
            : strings.add_service_detail
        }
        subtitle={branchName}
      >
        <ServiceDetailForm
          item={item}
          branchId={selectedBranch}
          serviceId={selectedService}
          onSaved={this.handleDone}
          onCancel={this.handleDone}
        />
      </FormPage>
    );
  }
}
